module.exports = __webpack_public_path__ + "static/media/epiccare-logo-new@2x.10e4600a.png";